exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-8e6d7b24]{margin:0 0 15px}", ""]);

// exports
